// Mobile-only Edit / Preview tab switcher for the Email editor screen.
// Per spec/build-plan.md P-032 row + Banks's pre-flight Ask 1 call
// ("two horizontal tabs for narrow screens, simple v1"). Extracted as
// a sibling so email-editor.tsx fits under the OC §3.1 ≤200-LOC target.
//
// **Hidden at md+** via the `md:hidden` class on the tablist root —
// the parent screen renders both panes side-by-side at desktop width
// and ignores the tab selection. The tab buttons mount unconditionally
// at mobile widths; pane visibility is driven by the parent's
// hidden/block class swap on the panes themselves (so neither pane
// remounts on tab change — Tiptap stays mounted, preview iframe stays
// loaded).

export type EmailEditorMobileTab = 'edit' | 'preview'

interface EmailEditorMobileTabsProps {
  readonly active: EmailEditorMobileTab
  readonly onChange: (tab: EmailEditorMobileTab) => void
}

const TAB_BASE_CLASS = 'flex-1 border-b-2 px-3 py-2 text-sm font-medium'
const TAB_ACTIVE_CLASS = 'border-ypo-navy text-ypo-navy'
const TAB_INACTIVE_CLASS = 'border-transparent text-gray-600 hover:bg-gray-50'

function tabClass(isActive: boolean): string {
  return `${TAB_BASE_CLASS} ${isActive ? TAB_ACTIVE_CLASS : TAB_INACTIVE_CLASS}`
}

export function EmailEditorMobileTabs({ active, onChange }: EmailEditorMobileTabsProps) {
  return (
    <div role="tablist" aria-label="Editor view" class="flex md:hidden">
      <button
        type="button"
        role="tab"
        aria-selected={active === 'edit'}
        class={tabClass(active === 'edit')}
        onClick={() => onChange('edit')}
      >
        Edit
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'preview'}
        class={tabClass(active === 'preview')}
        onClick={() => onChange('preview')}
      >
        Preview
      </button>
    </div>
  )
}
